import { Component, Input, OnInit } from '@angular/core';

import { IColunaCheckbox } from '../../interface/icm-checkbox-generico';

@Component({
    selector: 'icm-coluna-checkbox',
    templateUrl: './view/icm-coluna-checkbox.component.html',
    styleUrls: ['./view/icm-coluna-checkbox.component.scss'],
})
export class IcmColunaCheckboxComponent implements OnInit {
    @Input() linha;
    @Input() coluna: IColunaCheckbox;
    @Input() carregando: boolean;

    valor: boolean;
    textoTooltip: string;

    constructor() {}

    ngOnInit(): void {
        this.inicializarValores();
    }

    inicializarValores() {
        this.valor = this.coluna.valor(this.linha);
        if (this.coluna?.tooltip)
            this.textoTooltip = this.coluna.tooltip.valor(this.linha);
    }
}
